import Lazyload from 'lazyload';
let instance;
export default function lazyload() {
    if (instance) {
        instance.destroy();
    }
    instance = new Lazyload();
}
